import React from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'src/store'
import { Row, Col } from 'antd'
import moment from 'moment'

import { Title, Text } from 'src/components/Ant'

import { WrapSectionHeader } from './styles'

function SectionHeader() {
  const {
    reports: {
      reportsResources: {
        R1Data: { data },
        R1Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  let startDate = data.length > 0 ? data[0].receipt_date : null
  let endDate = data.length > 0 ? data[0].receipt_date : null

  data.forEach((item: any) => {
    if (item.receipt_date < startDate) {
      startDate = item.receipt_date
    }
    if (item.receipt_date > endDate) {
      endDate = item.receipt_date
    }
  })

  const period =
    data.length <= 0
      ? ' - '
      : `${moment.unix(startDate).format('DD/MM/YYYY')} - ${moment
          .unix(endDate)
          .format('DD/MM/YYYY')}`

  return (
    <WrapSectionHeader>
      <Row>
        <Col span={24}>
          <Title id="subtitle" level={4} title="web.report.1.header.title" />
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.1.header.organization">
            <span id="value">
              {(header[0] && header[0].organizacao_name) || ' - '}
            </span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.1.header.period">
            <span id="value">{period}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.1.header.approvers">
            <span id="value">
              {(header[0] && header[0].approvers_names) || ' - '}
            </span>
          </Text>
        </Col>
        <Col span={8}>
          <Text colon id="header" title="web.report.1.header.request_date">
            <span id="value">
              {(header[0] &&
                moment
                  .unix(header[0].request_date)
                  .utc()
                  .format('DD/MM/YYYY hh:mm')) ||
                ' - '}
            </span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Text colon id="header" title="web.report.1.header.reasons">
            <span id="value">
              {(header[0] && header[0].reasons_name) || ' - '}
            </span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Text colon id="header" title="web.report.1.header.targets">
            <span id="value">
              {(header[0] && header[0].targets_names) || ' - '}
            </span>
          </Text>
        </Col>
        <Col span={12}>
          <Text colon id="header" title="web.report.1.header.contracts">
            <span id="value">
              {(header[0] && header[0].contracts_names) || ' - '}
            </span>
          </Text>
        </Col>
      </Row>
    </WrapSectionHeader>
  )
}

export default SectionHeader
